import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    SelectInput: {
      maxWidth: "100%",
      width: 406,
      "& + &": {
        marginTop: theme.spacing(10),
      },
    },
    modalButton: {
      marginTop: theme.spacing(12),
    },
    dragDropText: {
      color: theme.gray400,
      fontSize: 13,
      opacity: "0.8",
    },
    dragDropWrapper: {
      margin: 0,
    },
    fullWidth: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },
    rightSideWrapper: {
      display: "flex",
      gap: theme.spacing(12),
    },
    chips: {
      height: "32px",
      borderRadius: "13px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(2, 4),
      backgroundColor: theme.gray100,
      gap: theme.spacing(5),
    },
    tooltipTitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      color: theme.gray800,
    },
  }),
);
